import { useEffect, useState } from 'react';

import { useParams } from 'next/navigation';

import { useFindTourLocationBySlug } from '@components/views/tour/hooks/search.query';

import { ITourSearchBarState } from '../types/tour';

/**
 * Convert the query params to the tour search bar state
 * @param query object
 * @returns Partial<ITourSearchBarState>
 */
export const useTourQuery = (enabled) => {
  const [values, setValues] = useState<Partial<ITourSearchBarState>>();
  const params = useParams();

  const tourSlug = params?.slug;

  const { data: tourLocation } = useFindTourLocationBySlug(
    tourSlug as string,
    enabled
  );

  /**
   * Set the tour location when change the tour slug
   */
  useEffect(() => {
    if (!tourLocation) return;
    setValues((previousValues) => ({
      ...previousValues,
      searchData: tourLocation,
    }));
  }, [tourLocation]);

  return values;
};
